export default class ProfileModel {
    constructor(firstName, middleName, lastName, birthday, gender, ethnicity) {

        // initialize the model
        Object.assign(this, { firstName, middleName, lastName, birthday, gender, ethnicity });

        // store the initial state as backup
        this._initialState = JSON.parse(JSON.stringify(this));
    }

    // wrap internal initial state in a wrapper to prevent overwrite using ".initialState ="
    // initialState can still be overwritten from outside using "._initialState =" since JS class variables are always public
    get initialState() {
        return this._initialState;
    }

    // restore initial state
    restoreInitialState() {
        Object.assign(this, this.initialState);
    }
}